import { useSignal } from "@preact/signals-react";

import { SearchIcon, XMarkIcon } from "components/Icons";
import { cn } from "tools/ui";

const style =
  "flex h-10 border border-gray-200 shadow-sm md:w-full rounded-xl py-1.5 px-2 text-md text-neutral-800 focus-within:border focus-within:border-cyan-500";

function SearchBar(props) {
  const { name, handleSearch, color, autoSearch, size } = props;
  const textSearch = useSignal("");

  const _color = color ?? "bg-white";

  function onChange(event) {
    const val = event.target.value;
    textSearch.value = val;
    if (autoSearch) {
      handleSearch(val);
    }
  }

  function searchAction(event) {
    const _event = event.nativeEvent;
    // keyCode = 13 is Enter
    if (event.keyCode === 13 || (_event && _event.type === "click")) {
      handleSearch(textSearch.value);
    }
  }

  function handleRemoveSearch() {
    textSearch.value = "";
    handleSearch("", true);
  }

  return (
    <div id="search-bar" className={cn(style, _color, size)}>
      <input
        type="text"
        name={name}
        key={name}
        value={textSearch}
        placeholder="Buscar..."
        onChange={onChange}
        onKeyDown={searchAction}
        className="h-6 w-full ml-1 my-auto placeholder-opacity-50 text-md placeholder:text-md focus:border-none focus:outline-none placeholder:text-neutral-400"
      />
      {textSearch.value && (
        <XMarkIcon
          key="clear-icon"
          onClick={handleRemoveSearch}
          className="m-auto mr-2 h-5 w-5 fill-current text-neutral-400 hover:text-rose-600 cursor-pointer active:scale-90"
          aria-hidden="true"
        />
      )}
      <SearchIcon
        key="search-icon"
        onClick={searchAction}
        className="m-auto h-5 w-5 fill-current text-neutral-500 active:text-sky-600 cursor-pointer active:scale-90 hover:text-blue-700"
        aria-hidden="true"
      />
    </div>
  );
}

export default SearchBar;
